import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var SnowIcon = function SnowIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "SnowIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M8.841 1.687a.687.687 0 1 0-1.373 0v.783l-.27-.135a.687.687 0 1 0-.613 1.228l.883.442v1.383l-1.228.714-1.202-.694.06-.986a.687.687 0 0 0-1.372-.082l-.018.3-.678-.391a.687.687 0 0 0-.686 1.189l.678.392-.251.165a.687.687 0 1 0 .756 1.146l.824-.544 1.198.691.004 1.421-1.202.694-.824-.544a.687.687 0 1 0-.756 1.146l.25.165-.677.392a.687.687 0 1 0 .686 1.19l.679-.392.018.3a.687.687 0 0 0 1.37-.082l-.059-.986 1.197-.691 1.233.707v1.387l-.883.442a.686.686 0 1 0 .614 1.228l.269-.135v.783a.687.687 0 1 0 1.373 0v-.783l.27.135a.687.687 0 0 0 .613-1.228l-.883-.442v-1.383l1.228-.714 1.202.694-.06.986a.687.687 0 0 0 1.372.082l.018-.3.678.391a.687.687 0 1 0 .686-1.189l-.678-.391.251-.166a.687.687 0 1 0-.756-1.146l-.824.544-1.198-.691-.004-1.421 1.202-.694.823.544a.687.687 0 1 0 .757-1.146l-.25-.166.677-.391a.687.687 0 1 0-.686-1.19l-.678.392-.019-.3a.687.687 0 0 0-1.37.082l.059.986-1.197.691-1.233-.707V4.005l.883-.442a.687.687 0 1 0-.614-1.228l-.269.135zM6.922 7.293l.004 1.421 1.233.707 1.228-.714-.004-1.421-1.233-.707z",
      clipRule: "evenodd"
    })
  }));
};

export { SnowIcon };
